<template>
<div class="counting-container">
    <Row type="flex">
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">输送机</div>
            <Row type="flex">
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-checked">原位</Radio>
                </Col>
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-unchecked">到位</Radio>
                </Col>

            </Row>
            <Row type="flex">
                <Col flex="1">
                    选择
                </Col>
                <Col flex="1">
                     <Select v-model="selectedTransMac" :placeholder="getTranslation('m034')">
                            <Option v-for="(item, key) in TransMacList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                </Col>
            </Row>
            <Row type="flex">
                
                <Col flex="1">
                    方向
                </Col>
                <Col flex="1">
                     
                </Col>
                <Col flex="1">
                    类型
                </Col>
                <Col flex="1">
                     
                </Col>
                <Col flex="1">
                    物料
                </Col>
                <Col flex="1">
                     
                </Col>
            </Row>
            
              <Row type="flex">
                <Col flex="1">
                    <Button type="primary" @click="transferPos('start')" :loading="loading">送料</Button>
                </Col>
                <Col>
                    <Button type="primary" @click="transferPos('return')" :loading="loading">回原</Button>
                </Col>
            </Row>
             
        </Card>
        </Col>
        <Col flex="1">
            <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">焊接气缸</div>
           <Row type="flex">
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-checked">原位</Radio>
                </Col>
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-unchecked">到位</Radio>
                </Col>

            </Row>
            <Row type="flex">
                <Col flex="1">
                    预压压力
                </Col>
                <Col flex="1">
                     
                </Col>
                <Col flex="1">
                    加压压力
                </Col>
                <Col flex="1">
                     
                </Col>
                <Col flex="1">
                    回程压力
                </Col>
                <Col flex="1">
                     
                </Col>
            </Row>
              <Row type="flex">
                <Col flex="1">
                    <Button type="primary" @click="normalControl('CmdMan0',1)" >预压</Button>
                </Col >
                <Col flex="1">
                    <Button type="primary" @click="normalControl('CmdMan0',2)" >加压</Button>
                </Col>
                  <Col flex="1">
                    <Button type="primary" @click="normalControl('CmdMan0',3)" >回程</Button>
                </Col>
            </Row>
             
        </Card>
        
        </Col>
    </Row>
    <Row type="flex">
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">静电极定位销</div>
          
            <Row type="flex">
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-checked">已顶出</Radio>
                </Col>
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-unchecked">已退回</Radio>
                </Col>

            </Row>
            
              <Row type="flex">
                <Col flex="1">
                    <Button type="primary" @click="normalControl('MaskFunc',2)" >顶出</Button>
                </Col>
                <Col>
                    <Button type="primary" @click="normalControl('MaskFunc',3)" >退回</Button>
                </Col>
            </Row>
             
        </Card>
        </Col>
        <Col flex="1">
            <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">吹气阀</div>
           
            <Row type="flex">
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-checked">开</Radio>
                </Col>
                <Col flex="1">
                    <Radio label="" disabled class="custom-radio-unchecked">关</Radio>
                </Col>

            </Row>
              <Row type="flex">
                <Col flex="1">
                    <Button type="primary" @click="normalControl('CmdMan0',4)" >开</Button>
                </Col >
                <Col flex="1">
                    <Button type="primary" @click="normalControl('CmdMan0',5)" >关</Button>
                </Col>
            </Row>
             
        </Card>
        
        </Col>
        <Col flex="2">
            <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">焊接控制器</div>
           
            <Row type="flex">
                <Col flex="1">
                    预焊
                </Col>
                <Col flex="1">
                    焊1 
                </Col>
                <Col flex="1">
                    焊2
                </Col>
                 <Col flex="1">
                    焊3
                </Col>
                 <Col flex="1">
                    后焊
                </Col>
                
               
            </Row>
              <Row type="flex">
                <Col flex="1">
                    <Button type="primary"  >规范查看</Button>
                </Col >
                <Col flex="1">
                    <Button type="primary" @click="normalControl('CmdDchgEn',0)" >放电</Button>
                </Col>
            </Row>
             
        </Card>
        
        </Col>
    </Row>

</div>
</template>

<script>
import axios from 'axios';
import {
    API_URL
} from '@/constants/const'
import {
    mapGetters
} from 'vuex'
import {
    postJsError
} from '@/util/util.js'
export default {
    name: 'WeldControl',
    props: {
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            selectedTransMac: 0,
            systemData: {},
            originalData: {},
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        TransMacList(){
            return [
                "输送机1",
                "输送机2",
                "输送机3",
                "输送机4",
            ]
        }
    },
    async created() {
        this.init();
    },
    methods: {
        async init() {
            const url = API_URL['501SystemGet'];
            let params = {
                mac: this.mac
            }
            let res = await axios.get(url, {
                    params: params
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
                if (res.data.data.param) {
                    for (var i in res.data.data.param) {
                        this.$set(this.systemData, i, res.data.data.param[i])
                    }
                    // 保存原始值快照
                    this.originalData = JSON.parse(JSON.stringify(this.systemData))
                }
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        async download(changed){
          const url = API_URL['501CommuDownload'];
            // 计算与原始值的差异，只发送变更的字段（nil 指针 = 不写入）
            
            
            let formData = new FormData();
            formData.append('mac', this.mac);
            formData.append('param', JSON.stringify(changed));
            let res = await axios.post(url, formData)
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
              // 写入成功，更新原始快照
              this.$Message.success(res.data.msg);
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        async transferPos(direction){
            // direction: 'start'(送料) or 'return'(回原)
            // Conveyor index → bit mapping:
            //   0(输送机1): start=bit6, return=bit7
            //   1(输送机2): start=bit8, return=bit9
            //   2(输送机3): start=bit10, return=bit11
            //   3(输送机4): start=bit12, return=bit13
            const i = this.selectedTransMac
            const offset = direction === 'start' ? 0 : 1
            const bit = 6 + i * 2 + offset
            const cmdMan1 = 1 << bit
            let changed = {
                'cmdMan1': cmdMan1,
            };
            await this.download(changed)
        },
        async normalControl(key,offset){
            const val = 1 << offset
            let changed = {}
            changed[key] = val
            await this.download(changed)
        }
    }
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.counting-container {
    padding: 10px;
}
.custom-radio-checked /deep/ .ivu-radio-inner {
    border-color: #19be6b !important;
    background-color: #19be6b !important;
}

.custom-radio-checked /deep/ .ivu-radio-inner:after {
    border-color: #fff !important;
}

.custom-radio-unchecked /deep/ .ivu-radio-inner {
    border-color: #dcdee2 !important;
    background-color: #f7f7f7 !important;
}
</style>
